 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		0: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"1":"dynamic-module-animation-carousel-panel-animation-carousel-panel-module-ngfactory","2":"dynamic-module-article-continued-panel-article-continued-panel-module-ngfactory","3":"dynamic-module-article-start-panel-article-start-panel-module-ngfactory","4":"dynamic-module-autosuggest-panel-autosuggest-panel-module-ngfactory","5":"dynamic-module-board-demo-panel-board-demo-panel-module-ngfactory","6":"dynamic-module-board-hero-demo-form-panel-board-hero-demo-form-panel-module-ngfactory","7":"dynamic-module-board-hero-panel-board-hero-panel-module-ngfactory","8":"dynamic-module-board-hero-video-panel-board-hero-video-panel-module-ngfactory","9":"dynamic-module-card-grid-panel-card-grid-panel-module-ngfactory","10":"dynamic-module-contact-form-panel-contact-form-panel-module-ngfactory","11":"dynamic-module-contact-panel-contact-panel-module-ngfactory","12":"dynamic-module-cookie-cookie-module-ngfactory","13":"dynamic-module-demo-form-panel-demo-form-panel-module-ngfactory","14":"dynamic-module-divider-panel-divider-panel-module-ngfactory","15":"dynamic-module-faq-image-panel-faq-image-panel-module-ngfactory","16":"dynamic-module-faq-panel-faq-panel-module-ngfactory","17":"dynamic-module-get-materials-panel-get-materials-panel-module-ngfactory","18":"dynamic-module-hero-panel-hero-panel-module-ngfactory","19":"dynamic-module-icon-panel-icon-panel-module-ngfactory","20":"dynamic-module-image-panel-image-panel-module-ngfactory","21":"dynamic-module-info-panel-info-card-panel-module-ngfactory","22":"dynamic-module-information-panel-information-panel-module-ngfactory","23":"dynamic-module-lib-panel-document-library-panel-document-library-panel-module-ngfactory","24":"dynamic-module-lib-panel-quote-panel-quote-panel-module-ngfactory","25":"dynamic-module-lib-panel-subscribe-panel-subscribe-panel-module-ngfactory","26":"dynamic-module-license-panel-license-panel-module-ngfactory","27":"dynamic-module-license-v2-panel-license-v2-panel-module-ngfactory","28":"dynamic-module-license-v3-panel-license-v3-panel-module-ngfactory","29":"dynamic-module-links-panel-links-panel-module-ngfactory","30":"dynamic-module-map-panel-map-panel-module-ngfactory","31":"dynamic-module-maps-panel-maps-panel-module-ngfactory","32":"dynamic-module-news-panel-news-panel-module-ngfactory","33":"dynamic-module-onboarding-panel-onboarding-panel-module-ngfactory","34":"dynamic-module-prices-table-panel-prices-table-panel-module-ngfactory","35":"dynamic-module-profiles-panel-profiles-panel-module-ngfactory","36":"dynamic-module-references-panel-references-panel-module-ngfactory","37":"dynamic-module-rte-panel-rte-panel-module-ngfactory","38":"dynamic-module-security-panel-security-panel-module-ngfactory","39":"dynamic-module-sidescrolling-logos-panel-sidescrolling-logos-panel-module-ngfactory","40":"dynamic-module-spot-panel-spot-panel-module-ngfactory","41":"dynamic-module-table-panel-table-panel-module-ngfactory","42":"dynamic-module-testimonials-panel-testimonials-panel-module-ngfactory","43":"dynamic-module-text-panel-text-panel-module-ngfactory","44":"dynamic-module-two-col-two-row-panel-two-col-two-row-panel-module-ngfactory","45":"dynamic-module-two-columns-panel-two-columns-panel-module-ngfactory","46":"dynamic-module-user-guide-panel-user-guide-panel-module-ngfactory","47":"dynamic-module-video-carousel-panel-video-carousel-panel-module-ngfactory","48":"dynamic-module-video-panel-video-panel-module-ngfactory","49":"dynamic-module-video-testimonials-panel-video-testimonials-panel-module-ngfactory"}[chunkId]||chunkId) + "." + {"1":"9896ca842424751e7cf2","2":"458701b74fb970b0b45d","3":"3a5945325a0b0a9881dd","4":"919d00cd075e944923d7","5":"41862297a5b4ebd9f82b","6":"bfb6a9ad0b30ee94c66a","7":"40bd916d4eba2e1eef50","8":"73102fdf576d7c5fce2e","9":"7b1b9a5641cda8d21d69","10":"5342f21ed6713756904d","11":"929bce0b2b4f8f9aacfb","12":"2688b67e4798b654b61f","13":"024d80e73df840bf5625","14":"6330ce38277c7c7104bc","15":"b9d93fc662bc49484ff0","16":"74fe0d3f25da7c868583","17":"c60ce32a53dc3e04e712","18":"b44d2096a23ebf6aa530","19":"32a765843e9acea523c2","20":"451590bfaad95ce3910b","21":"9202d37dd5acef7f137a","22":"cf636c682c2291071a28","23":"800bc8f39084e6e3d088","24":"aca02fa372acd1ab2e85","25":"f433c7718dfdb7009bb1","26":"9aa850b5d03ad7d8bd3a","27":"a031338ea958db800e1c","28":"1d273b338491492df713","29":"cc9237c0f67a59a77c55","30":"13944ddd520ece68b5f2","31":"e425ec098a83d7946fee","32":"4cc2a8e7132f27eac2b6","33":"f8d7ea9ffebce9812a98","34":"779e1e2d4f61cf064416","35":"1df6bea2aa1947a67e14","36":"a0d631831b066712bf3e","37":"e9fabbb485b7f38208c6","38":"c58a21aa75c9ee01b007","39":"330fa5bbd29899440842","40":"0bc2fdb015cf13341456","41":"bca733e8dc2f2d23b65a","42":"fd750928d75ae4d2bde7","43":"f13e5c58130ea7043cf2","44":"6e18cf419c6251cbf9fe","45":"3629d8b86f9f98248667","46":"8299cbf61f5ee17a8ac2","47":"3793adc94439e532cedb","48":"8b1983cf174f7ea4c397","49":"7b77ebdff559bc6aee4c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/wwwroot/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
